import { RootState } from "@/modules/common";

export const selectVATAmount = (state: RootState) =>
  state.basket.basket.VATAmount;
